module.exports = __webpack_public_path__ + "img/pic_1.604ee2f1.png";